"use client";

import { Icon } from "@pamperedchef/design-system";
import * as styles from "./RecipePairingsCard.module.scss";

export interface RecipePairingsCardRecipe {
	title: string;
	href: string;
	description?: string;
	image?: { src: string; alt: string };
	prepTimeInMinute?: number;
	cookTimeInMinute?: number;
}

export interface RecipePairingsCardProps {
	recipe: RecipePairingsCardRecipe;
}

export function RecipePairingsCard({ recipe }: RecipePairingsCardProps) {
	const timeLine = formatTimes(
		recipe.prepTimeInMinute,
		recipe.cookTimeInMinute
	);
	return (
		<article className={styles["card"]} data-component="RecipePairingsCard">
			{recipe.image ? (
				<div className={styles["image-wrap"]}>
					{/* composites/ is isolated — can't import next/image (docs/PDP_ARCHITECTURE.md). */}
					{/* eslint-disable-next-line @next/next/no-img-element */}
					<img
						className={styles["image"]}
						src={recipe.image.src}
						alt={recipe.image.alt}
						loading="lazy"
					/>
				</div>
			) : (
				<div className={styles["image-wrap"]} aria-hidden />
			)}
			<div className={styles["content"]}>
				<a className={styles["title"]} href={recipe.href}>
					{recipe.title}
				</a>
				{timeLine ? (
					<div className={styles["times"]}>
						<span className={styles["times-icon"]} aria-hidden>
							<Icon name="Clock" width={20} height={20} />
						</span>
						<span>{timeLine}</span>
					</div>
				) : null}
				{recipe.description ? (
					<p className={styles["description"]}>
						{recipe.description}
					</p>
				) : null}
			</div>
		</article>
	);
}

function formatTimes(prep?: number, cook?: number): string | null {
	const parts: string[] = [];
	if (typeof prep === "number") parts.push(`Prep ${prep} min`);
	if (typeof cook === "number") parts.push(`Cook ${cook} min`);
	return parts.length > 0 ? parts.join(" | ") : null;
}
